<template>
    <div class="form-input" :class="[classString, {'error': error}, {'locked': element.locked === true, 'unlocked' : element.locked === false}]">
        <span v-if="element.isTemplateContentEdit" class="padlock-wrapper"><label :for="element.name"><Label :label="element.label" :tooltip="element.tooltip" /></label><Lock :locked="element.locked" @toggleLocked="toggleLockedState($event)" /></span>
        <label v-else :for="element.name" class="lock"><Label :label="element.label" :tooltip="element.tooltip" /></label>

        <textarea-autosize :id="element.name" :placeholder="element.placeholder" :rows="numRows" cols="50" v-model="inputValue" :disabled="element.disabled" :readonly="element.readonly" @focus.native="onInputFocusStandard" @blur.native="onInputBlurStandard"></textarea-autosize>
        <span class="error-message" v-if="error">{{error}}</span>
    </div>
</template>

<script>

    import {formElementMixin} from "@/components/mixins/formelement";

    import Label from "@/components/form/label";
    import Lock from "@/components/form/lock";
    // import {log} from "@/shared/utils";

    export default {
        name: "Formelement_textarea",
        components: {Label, Lock},
        mixins: [formElementMixin],
        props: {
            element: {
                type: Object
            },
            value: {
                type: String
            },
            classString: {
                type: String
            }
        },
        computed: {
            inputValue: {
                get() { return this.value },
                set(inputValue) {this.$emit('input', inputValue)}
            },
            numRows() {
                return this.element.rows ? this.element.rows : 4;
            }
        },
        updated() {
            //log(["textarea element updated", this.element.name]);
        },
    }
</script>
